// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"f88a0192","977":"29f78a79"}[chunkId] + ".chunk.js";
};